module.exports = __webpack_public_path__ + "static/media/explore-artwork.94c0b732.gif";